/* eslint-disable */
require('./arrow_light')
require('./BAROMETER')
require('./bin')
require('./clear')
require('./cross')
require('./duplicate')
require('./EN')
require('./ES')
require('./eye')
require('./FR')
require('./idalgo')
require('./IT')
require('./link')
require('./media')
require('./multiproducts')
require('./pen')
require('./PLAYERLIST')
require('./save')
require('./search')
require('./setting')



// WEBPACK FOOTER //
// ./src/components/icons/index.js